import React from 'react';
import { Route } from 'react-router-dom';
import { ApplicationModule } from '../shared/applicationModule';
import { LlmChatToggleWrapper } from 'feature-toggle';
import LlmChatPage from './LlmChatPage';

export default function useLlmChatModule(): ApplicationModule {
  const getRouter = () => {
    return (
      <>
        <Route
          path="/chats"
          element={(
            <LlmChatToggleWrapper>
              <LlmChatPage />
            </LlmChatToggleWrapper>
          )}
        />
        <Route
          path="/chats/:chatId"
          element={(
            <LlmChatToggleWrapper>
              <LlmChatPage />
            </LlmChatToggleWrapper>
          )}
        />
      </>
    );
  };

  return {
    getRouter,
    name: 'llmchat',
  };
}
